import { render } from "./CChartBarSimple.vue?vue&type=template&id=7d2c10e8"
import script from "./CChartBarSimple.vue?vue&type=script&lang=js"
export * from "./CChartBarSimple.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__